import React from 'react';
import CommonModal from "../commonModal/CommonModal.jsx";
import CommonButton from "../../ui/CommonButton/CommonButton.jsx";
import './ErrorBoundaryModal.scss';
const reloadPage = () => {
  window.location.reload();
};
const ErrorBoundaryModal = ({
  message,
  details,
  onReload = reloadPage
}) => {
  const safeMessage = message?.trim() || 'Something went wrong while loading this page.';
  const safeDetails = details?.trim() || 'No additional error details are available.';
  return <CommonModal show handleClose={onReload} disableClose backdrop="static" className="ErrorBoundaryModal" backdropClassName="transaction_modal_bckdrop" heading="Something went wrong">
      <div className="errorBoundaryModal">
        <p className="errorBoundaryModal__message">{safeMessage}</p>
        <p className="errorBoundaryModal__hint">
          You can reload the page to try again. If the problem continues, contact support.
        </p>
        <details className="errorBoundaryModal__details">
          <summary>Error details</summary>
          <pre>{safeDetails}</pre>
        </details>
        <div className="errorBoundaryModal__actions">
          <CommonButton title="Reload Page" type="button" onClick={onReload} className="w-100" />
        </div>
      </div>
    </CommonModal>;
};
export default ErrorBoundaryModal;